
export default {
  map: null,
  rutePath: null
}




// WEBPACK FOOTER //
// ./src/store/state.js